var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumber3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128.000000pt",
    height: "128.000000pt",
    viewBox: "0 0 128.000000 128.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M539 1266 c-106 -28 -211 -122 -248 -222 -40 -105 -20 -172 59 -195 32 -10 44 -9 77 7 31 15 42 29 60 74 12 30 37 69 57 87 30 28 43 33 86 33 60 0 100 -19 130 -60 66 -93 9 -219 -107 -236 -89 -13 -123 -44 -123 -114 0 -70 34 -101 123 -114 116 -17 173 -143 107 -236 -30 -41 -70 -60 -130 -60 -43 0 -56 5 -86 33 -20 18 -45 57 -57 87 -18 45 -29 59 -60 74 -33 16 -45 17 -77 7 -50 -15 -80 -53 -80 -102 0 -105 91 -234 204 -289 165 -82 371 -27 472 124 89 134 86 307 -6 435 l-30 41 30 41 c45 63 70 140 70 218 0 85 -19 148 -64 217 -86 129 -255 191 -407 150z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber3);
export default __webpack_public_path__ + "static/media/number-3.cf16e6a172fcc843983fb7f1edd3cac0.svg";
export { ForwardRef as ReactComponent };